<template>
  <v-app>
    <v-content class="content">
      <demo-warning v-if="demoMode" />
      <splash-screen />
      <mapbox-box />
      <div v-if="mapOnlyMode == null || mapOnlyMode == false">
        <pop-menu :dist="$mq | mq({ mobile: 9, tablet: 12 })" />
        <search-view />
      </div>
      <layer-view />
      <settings-view />
      <detail-view />
      <legend-view />
    </v-content>
  </v-app>
</template>

<script>
import SplashScreen from './components/SplashScreen.vue';
import DemoWarning from './components/DemoWarning.vue';
import PopMenu from './components/PopMenu.vue';
import MapboxBox from './components/mapbox/MapboxBox.vue';
import SearchView from './components/search-view/SearchView.vue';
import LayerView from './components/layer-view/LayerView.vue';
import SettingsView from './components/settings-view/SettingsView.vue';
import DetailView from './components/search-view/DetailView.vue';
import LegendView from './components/legend-view/LegendView.vue';

export default {
  name: 'App',
  metaInfo: {
    meta: [
      { name: 'viewport', content: 'user-scalable=0,initial-scale=1, maximum-scale=1,width=device-width' },
      { name: 'theme-color', content: '#000000' },
      { name: 'apple-mobile-web-app-status-bar-style', content: 'black' },
    ],
  },
  components: {
    SplashScreen,
    MapboxBox,
    PopMenu,
    SearchView,
    LayerView,
    SettingsView,
    DetailView,
    DemoWarning,
    LegendView,
  },
  data() {
    return {
      demoMode: this.$appConfig.demoMode,
      mapOnlyMode: this.$appConfig.mapOnlyMode
    };
  },
  computed: {
    windowWidth() {
      return window.innerWidth;
    },
    windowHeight() {
      return window.innerWidth;
    },
    mediaquery() {
      return this.$mq;
    },
  },
  watch: {
    mediaquery(nv) {
      switch (nv) {
        case 'mobile':
          this.$store.commit('enterModeMobile');
          break;
        case 'tablet':
          this.$store.commit('enterModeTablet');
          break;
        case 'desktop':
          this.$store.commit('showSearchMenu');
          this.$store.commit('toggleSubMenus');

          this.$store.commit('enterModeDesktop');
          break;
        default:
          break;
      }
      this.$store.commit('closeAllMenus');
      // FIXME proper rerendering whole vue on resizing
      this.$forceUpdate();
    },
  },
  beforeCreate() {
  },
  created() {
    document.title = this.$appConfig.title;
  },
  methods: {},
};
</script>
<style scoped>
.content {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
/* BUG remove scroll bar from whole app window */
.remove-scroll-bar {
  -ms-overflow-style: none;  /* IE 10+ */
  scrollbar-width: none;  /* Firefox */
}
.remove-scroll-bar::-webkit-scrollbar {
  display: none;
}
</style>
<style lang="css">
@import 'static/vuetify-override.css';
</style>
<style lang="css">
@import 'static/main.css';
</style>
